<script setup lang="ts">
import 'swagger-ui/dist/swagger-ui.css';
import SwaggerUI from 'swagger-ui';
import {usePartnerConfig} from "~/stores/usePartnerConfig";

const { domain } = usePartnerConfig();

onMounted(() => {
  if (domain.value) {
    SwaggerUI({
      dom_id: '#swagger-ui',
      url: `https://api.${domain.value}/storage/swagger/swagger-user.yml`,
    });
  }
});
</script>

<template>
  <div class="swagger">
    <div id="swagger-ui" />
  </div>
</template>

<style scoped lang="scss">
#swagger-ui {
  :deep(.info) {
    display: none;
  }
  :deep(.models) {
    display: none;
  }
}
</style>
